import axios from "axios";

export const state = {
    patientconsentforms: [],
};

export const getters = {
    patientconsentforms: state => state.patientconsentforms,
};

export const mutations = {
    setConsentForms(state, newValue) {
        state.patientconsentforms = newValue
    },
};

export const actions = {
    fetchPatientConsentForms({ commit }, params = {}) {
        return axios.get('/patientconsentforms', { params }).then(res => {
            commit('setConsentForms', res.data.consentforms)
            return res;
        })
    },
};
